import './styles.css';
import { setupEmbed } from './embed';
import { initCalculator } from './calculator';
import { initTabs, type Tabs } from './tabs';
import { initVergleich } from './vergleich';

setupEmbed();

function init(): void {
  // The Rechner initializes regardless of the start tab (W1 behaviour kept);
  // the Zinsvergleich loads its rates lazily on first tab activation.
  initCalculator();
  // `tabs` is referenced lazily (bridge click) — initTabs runs first is fine.
  const vergleich = initVergleich(() => tabs.switchTo('rechner'));
  const tabs: Tabs = initTabs((view) => {
    if (view === 'vergleich') vergleich.onShow();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
